import { clone } from 'ramda'
class groupMessage {
  /* @ngInject */
  constructor (ToastService, $mdDialog, $mdToast, $q, Message, $rootScope, users) {
    this.ToastService = ToastService
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$rootScope = $rootScope
    this.$q = $q
    this.Message = Message
    this.message = ''

    this.sendText = false
    this.sendIntercom = false
    this.singleUserMessage = false
    this.singleUserMessagesLoading = false
    this.users = users
    this.charLimit = false
    if (users.length === 1) {
      this.singleUserMessage = true
    }
  }

  getIntercomMessages () {
    this.singleUserMessagesLoading = true
    this.Message.getIntercomConversations({userId: this.users[0]})
      .then((conv) => {
        this.intercomMessages = conv.body.conversations
        this.singleUserMessagesLoading = false
      })
      // function (err, result) {
      //   if (err) {
      //     this.$mdToast.showSimple('No Intercom User found for the email you are trying to message')
      //   }
      //   this.intercomMessages = result
      // })
  }

  confirm () {
    if (!this.message) {
      return this.$mdToast.showSimple('Please Enter a Message')
    }

    let userIds = []
    let messages = []

    userIds = this.users

    for (var i = 0; i < userIds.length; i++) {
      messages.push(clone(this.message))
    }

    let query = {userIds, messages, fromCompany: false}

    let calls = []

    if (this.sendText) calls.push(this.Message.messageGroup(query))
    if (this.sendIntercom) calls.push(this.Message.intercomGroup(query))
    this.$rootScope.$broadcast('app:loading:start')
    this.$q.all(calls)
      .then(this.sendMessageSuccess.bind(this), this.sendMessageError.bind(this))

    this.$mdDialog.hide()
  }

  updateCharLimit () {
    const inputText = this.message.trim()
    this.charLimit = inputText.length > 160
  }

  sendMessageError (err) {
    this.$rootScope.$broadcast('app:loading:done')
    if (!err) return
    this.$mdToast.showSimple('Unable to send group message.')
  }

  sendMessageSuccess (res) {
    let textReturn = this.sendText ? res[0] : ''
    let intercomReturn = ''
    if (this.sendIntercom) {
      intercomReturn = this.sendText ? res[1] : res[0]
    }

    var message = ''
    if (this.sendText) {
      message = 'Text ' + textReturn.toLowerCase()
    }

    if (intercomReturn.message) {
      var intercomMessage = intercomReturn.message.charAt(0).toUpperCase() + intercomReturn.message.slice(1)

      message = message ? intercomMessage + ', ' + message.toLowerCase() : intercomMessage
    }

    this.$rootScope.$broadcast('app:loading:done')
    this.ToastService.showWarning(message)
  }

  cancel () {
    this.$mdDialog.cancel()
  }

}

export default groupMessage
